const G = "#b8960c";

const SERVICES = [
  { title: "IT Systems Administration", desc: "Full device lifecycle, MDM (Jamf, Intune), identity & access across Okta, Azure AD, Google Workspace.", icon: "🖥️" },
  { title: "Scripting & Automation", desc: "Custom Python, PowerShell & Bash scripts to automate workflows and integrate SaaS APIs.", icon: "⚡" },
  { title: "Network Infrastructure", desc: "DHCP, TCP/IP, VPN, VLAN and firewall configuration with high-availability targets.", icon: "🌐" },
  { title: "IT Support & Helpdesk", desc: "Tier 1–3 support, SLA-compliant queue management via Jira & Zendesk.", icon: "🛠️" },
  { title: "Security & Compliance", desc: "InfoSec-aligned on/offboarding, access revocation and device wiping.", icon: "🔐" },
  { title: "Software Engineering", desc: "Internal tools, APIs and automation solutions using Python, SQL and Bash.", icon: "💡" },
];

const SKILLS = [
  { cat: "Apple & Device Mgmt", items: ["Jamf Pro", "Apple Business Manager", "Intune", "Mosyle Fuse", "macOS", "iOS"] },
  { cat: "Identity & SaaS", items: ["Okta", "Azure AD", "Google Workspace", "Microsoft 365", "Jira", "Zendesk"] },
  { cat: "Scripting & APIs", items: ["Python", "PowerShell", "Bash", "SQL"] },
  { cat: "Networking", items: ["TCP/IP", "DHCP", "VPN", "VLAN", "Firewalls"] },
];

function DarkTag({ children }) {
  return <span className="inline-block px-2 py-0.5 text-[11px] border border-white/10 text-gray-400 bg-white/5 rounded-sm mr-1 mt-1 hover:text-yellow-500 transition-all cursor-default">{children}</span>;
}

function SectionHeader({ label, title }) {
  return (
    <div className="mb-4">
      <p className="text-xs tracking-[0.25em] uppercase mb-1 font-semibold" style={{ color: G }}>{label}</p>
      <h2 style={{ fontFamily: 'Playfair Display, serif' }} className="text-3xl sm:text-4xl font-black text-white">{title}</h2>
      <div className="w-10 h-0.5 mt-2" style={{ background: G }} />
    </div>
  );
}

export default function Services({ refs }) {
  return (
    <section id="Services" ref={el => (refs.current["Services"] = el)} className="py-8">
      <SectionHeader label="What I Offer" title="Services" />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
        {SERVICES.map(s => (
          <div key={s.title} className="border border-white/8 rounded-sm p-4 sm:p-5 hover:border-yellow-600/30 transition-all" style={{ background: "#1a1a1a" }}>
            <div className="text-2xl mb-2">{s.icon}</div>
            <h3 style={{ fontFamily: 'Playfair Display, serif' }} className="text-white font-bold text-sm mb-1">{s.title}</h3>
            <p className="text-xs text-gray-500 leading-relaxed">{s.desc}</p>
          </div>
        ))}
      </div>
      <div className="border border-white/8 rounded-sm p-4 sm:p-5" style={{ background: "#1a1a1a" }}>
        <h3 style={{ fontFamily: 'Playfair Display, serif' }} className="text-white font-bold text-lg mb-4">Skills & Tools</h3>
        <div className="space-y-3">
          {SKILLS.map(s => (
            <div key={s.cat} className="flex flex-col sm:flex-row gap-1 sm:gap-3 items-start flex-wrap">
              <span className="text-xs font-semibold sm:min-w-[148px] pt-1 tracking-wide uppercase" style={{ color: G }}>{s.cat}</span>
              <div className="flex flex-wrap">{s.items.map(i => <DarkTag key={i}>{i}</DarkTag>)}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}